import React from 'react';
import { Box, Typography } from '@mui/material';
import appColors from '../../app_colors';
import appStrings from '../../app_strings';
import { appBorders } from '../../app_borders';
import { BackrsForm } from '../../molecules/BackrsForm/BackrsForm';
import { ResendCode } from '../../molecules/ResendCode/ResendCode';

const LOGIN_STRINGS = appStrings.login.unified;

const defaultOtpValues = {
  code: '',
};

const containerStyle = {
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  px: 4,
  backgroundColor: appColors.primaryAppBackground,
};

const loginFormStyle = {
  backgroundColor: appColors.container.white,
  paddingX: 2,
  paddingY: 3,
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '100%',
  width: '100%',
  boxSizing: 'border-box',
  '@media (min-width: 300px)': {
    paddingX: 2,
    paddingY: 4,
  },
  '@media (min-width: 600px)': {
    maxWidth: '500px',
    paddingX: 11,
    paddingY: 8,
  },
  ...appBorders.backrsDropShadowBorders.black,
};

const responsiveBackrsLogoStyle = {
  width: '100%',
  maxWidth: '175px',
  padding: '8px',
  marginBottom: '32px',
};

const otpPromptStyle = {
  maxWidth: '300px',
  color: appColors.text.darkNavy,
  fontSize: '1.5rem',
  fontWeight: 700,
  textAlign: 'center',
  mb: 3,
};

const otpContentWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const otpDecorationContainerStyle = {
  width: '100%',
  maxWidth: '350px',
  padding: 1,
};

const otpInputStyle = {
  mb: 4,
};

const otpInputProps = {
  style: { textAlign: 'center', letterSpacing: '0.75rem', fontSize: '1.5rem' },
  maxLength: 6,
};

export const OneTimePassword = ({
  handleOtpCode, errorMessage, environmentUrl, clearError,
}) => {
  const fields = [
    {
      id: 'code',
      name: 'code',
      placeholder: '######',
      type: 'tel',
      autoComplete: 'code',
      sx: otpInputStyle,
      inputProps: otpInputProps,
    },
  ];

  const handleSubmission = async (data) => {
    await handleOtpCode(data.code);
  };

  const handleResend = async () => {
    clearError();
  };

  return (
    <Box sx={containerStyle}>
      <Box
        component="img"
        src="/assets/backrs-with-text.svg"
        alt="backrs logo with text"
        sx={responsiveBackrsLogoStyle}
      />
      <Box sx={loginFormStyle}>
        <Typography variant="h4" sx={otpPromptStyle}>
          {LOGIN_STRINGS.otp.title}
        </Typography>
        <BackrsForm
          fields={fields}
          defaultValues={defaultOtpValues}
          onSubmit={handleSubmission}
          buttonLabel={LOGIN_STRINGS.otp.logIn}
        >
          <Box sx={otpContentWrapperStyle}>
            <ResendCode environmentUrl={environmentUrl} onResend={handleResend} />
            <Box
              component="img"
              src="/assets/otp-decoration.svg"
              alt="backrs logo with text"
              sx={otpDecorationContainerStyle}
            />
          </Box>
        </BackrsForm>
        {errorMessage && (
          <Box mt={2} color={appColors.text.red}>
            {errorMessage}
          </Box>
        )}
      </Box>
    </Box>
  );
};
